module.exports = __webpack_public_path__ + "img/bs.5d69eed9.png";